export const ARIA_SuccessCode = "00";
export const ARIA_DATA_STILL_BEING_USED = "6";
export const ARIA_NOT_FOUND = "1004";
export const ARIA_RECORD_EXISTED = "1006";
export const ARIA_INVALID_PASSWORD = "2000";
export const ARIA_RESERVATION_NOT_FOUND = "3000";
export const ARIA_RESERVATION_ALREADY_PREREGISTERED = "3001";
export const ARIA_PMS_CONNECTOR_ERROR = "3009";